
export type TweetResponseTags = {
  hashtagIds?: string[];
};
